import { render, staticRenderFns } from "./AgentMenu.vue?vue&type=template&id=00ff66d4&scoped=true&"
import script from "./AgentMenu.vue?vue&type=script&lang=js&"
export * from "./AgentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff66d4",
  null
  
)

export default component.exports